import React from 'react';

export default class TrialItem01 extends React.Component {
	constructor (props) {
		super(props);
		
	}

	render () {
	
		
		return (
			<>   
        <div onClick={this.props.handler} className="block-box cursor-point">
          <div className="w100 mx120 mg-ct pd-s40 m-hidden">
            <div className="image-r image-f img100" style={{backgroundImage: "url('/img/icon/footer/computer.svg')"}}></div>
          </div>
          <p className="ft4 ft-b ft-wh txt-center mg-t10 m-ft4">무료체험판</p>
          <p className="ft5 ft-lt ft-wh txt-center mg-t5 m-ft5">DEMO</p>
          <p className="txt-center mg-t5">
            <i className="ft-mi ft5 ft-c2">fiber_manual_record</i>
          </p>
        </div>
			</>
		)
	}

}